
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artigos-uteis/[slug]",
      function () {
        return require("private-next-pages/artigos-uteis/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artigos-uteis/[slug]"])
      });
    }
  